import { render, staticRenderFns } from "./WidgetProjectDownload.vue?vue&type=template&id=81f39ef6&scoped=true"
import script from "./WidgetProjectDownload.vue?vue&type=script&lang=js"
export * from "./WidgetProjectDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f39ef6",
  null
  
)

export default component.exports